import { gsap } from "gsap";

/**
 * Contact Panel
 * Expands/collapses the contact form inline within the header bar
 */
export function initContactPanel() {
  const toggle = document.getElementById('contact-toggle');
  const panel = document.getElementById('contact-panel');
  const header = document.getElementById('site-header');
  const selects = panel.getElementsByTagName('select');
  const footer = document.getElementById('site-footer');

  const isFrench = window.location.href.includes('/fr');
  const inputs = panel.querySelectorAll('input, textarea');

  if (isFrench) {
    inputs.forEach(input => {
      if (input.placeholder == "Name") input.placeholder = "Nom";
      else if (input.placeholder == "Email") input.placeholder = "Courriel";
      else if (input.placeholder == "Type your message") input.placeholder = "Écrivez votre message";
      else if (input.value == "SEND") input.value = "ENVOYER";
    });
  }

  // Set color depending on placeholder vs value
  // Needed because some browsers override the <option>'s color with the
  // <select>'s color.
  for (let sel of selects) {
    const updateColor = () => {
      if (sel.selectedOptions[0].className.includes('gf_placeholder')) {
        sel.style.color = '#363638';
      } else {
        sel.style.color = '#c6cdd5';
      }
    };
    updateColor(); // call once to set initial color
    sel.addEventListener('change', updateColor);
  }

  if (!toggle || !panel || !header) return;

  let isAnimating = false;

  toggle.addEventListener('click', function() {
    if (isAnimating) return;
    isAnimating = true;

    const isOpen = header.classList.contains('contact-open');

    if (!isOpen) {
      // OPEN: shrink header first (0.4s CSS transition on __inner), then open panel
      header.classList.add('contact-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      toggle.textContent = isFrench ? 'FERMER' : 'CLOSE';

      gsap.set(panel, { height: 0 });
      gsap.to(panel, {
        height: 'auto',
        duration: 0.65,
        ease: 'power2.out',
        delay: 0.4,
        onComplete: function() {
          isAnimating = false;
        }
      });
    } else {
      // CLOSE: animate height to 0, then remove class
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'CONTACT';

      gsap.to(panel, {
        height: 0,
        duration: 0.65,
        ease: 'power2.in',
        onComplete: function() {
          header.classList.remove('contact-open');
          panel.setAttribute('aria-hidden', 'true');
          gsap.set(panel, { clearProps: 'height' });
          isAnimating = false;
        }
      });
    }
  });

  // Allow any .js-open-contact button to open the panel
  document.querySelectorAll('.js-open-contact').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (!header.classList.contains('contact-open')) {
        toggle.click();
      }
      header.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && header.classList.contains('contact-open')) {
      // Simulate toggle click to close with transition
      toggle.click();
    }
  });
}

/**
 * Contact Form Validation
 * Hides per-field GF validation messages and shows a single
 * "Field missing." error above the submit button instead.
 */
export function initContactFormValidation() {
  var formId = 1;

  function showError(wrapper) {
    var footer = wrapper.querySelector('.gform-footer, .gform_footer');
    if (!footer) return;
    var errEl = wrapper.querySelector('.contact-single-error');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'contact-single-error';
      errEl.textContent = 'Field missing.';
      footer.parentNode.insertBefore(errEl, footer);
    }
    errEl.style.display = '';
  }

  function hideError(wrapper) {
    var errEl = wrapper.querySelector('.contact-single-error');
    if (errEl) errEl.style.display = 'none';
  }

  function setup() {
    var wrapper = document.getElementById('gform_wrapper_' + formId);
    if (!wrapper) return;

    if (wrapper.classList.contains('gform_validation_error')) {
      showError(wrapper);
    }

    var obs = new MutationObserver(function() {
      if (wrapper.classList.contains('gform_validation_error')) {
        showError(wrapper);
      } else {
        hideError(wrapper);
      }
    });
    obs.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
  }

  setup();

  // Re-run after each GF AJAX re-render
  if (window.jQuery) {
    jQuery(document).on('gform_post_render', function(e, id) {
      if (id === formId) {
        setTimeout(setup, 0);
      }
    });
  }
}

